export const state = () => {
  return {
    channels: [],
    selectedChannel: null,
    users: [],
    allUsers: []
  };
};

export const actions = {
  async RESET_ALL_STATE({commit}) {
    commit('resetAllState')
  },
  async GET_LIST_CHANNELS({commit}, projectId) {
    const {data} = await this.$frontendRepositories.channels.getList(projectId)

    //commit('setChannels', data.data);
    return data.data;
  },
  async DELETE_CHANNEL({commit}, channel) {
    const {data} = await this.$frontendRepositories.channels.deleteChannel(channel.id);

    //commit('deleteChannel', channel)

    return data;
  },
  async CREATE_CHANNEL({commit}, {projectId, payload}) {
    const {data} = await this.$frontendRepositories.channels.createChannel(projectId, payload)

    commit('addChannel', data.data)
  },
  async UPDATE_CHANNEL({commit}, {id, payload}) {
    await this.$frontendRepositories.channels.updateChannel(id, payload)
  },
  GET_MESSAGES_BY_CHANNEL_ID(_, {channel_id, last_id}) {
    return this.$frontendRepositories.channels.getMessagesByChannelId(channel_id, last_id);
  },
  async GET_USERS_IN_CHANNEL({commit}, channelId) {
    const {data} = await this.$frontendRepositories.channels.getUsersInChannel(channelId);

    commit('setUsers', data.data)
  },
  async GET_USERS_IN_PROJECT({commit, rootState}, projectId) {
    const {data} = await this.$frontendRepositories.channels.getUsersInProject(projectId);
    commit('setAllUsers', data.data.filter(user => {
      return user.deleted_at === null
    }))
  },
  SET_SELECTED_CHANNEL({commit}, channelId) {
    commit('setSelectedChannel', channelId)
  },
  async LOAD_NEW_MESSAGES({state}, latestMessageId) {
    const {data} = await this.$frontendRepositories.channels.loadNewMessages(state.selectedChannel.id, latestMessageId);

    return data.data;
  },
  async MARK_SEEN({commit}, channel) {
    await this.$frontendRepositories.channels.markSeen(channel.id);

    commit('setMarkSeen', channel)
  },
  async CREATE_MESSAGE({commit}, payload) {
    const {data} = await this.$frontendRepositories.channels.createMessage(payload)

    commit('setLatestMessageForChannel', {
      message: data.data,
      channel_id: payload.channel_id
    })

    return data;
  },
  async INVITE_USER({commit}, {user, channelId, projectId}) {
    await this.$frontendRepositories.channels.inviteUser(channelId, user.id, projectId);

    commit('addUser', user)
  },
  async REMOVE_USER({commit}, {user, channelId}) {
    await this.$frontendRepositories.channels.removeUser(channelId, user.id);

    commit('removeUser', user)
  },
  async DELETE_MESSAGE({commit}, {message, lastMessage}) {
    let response = await this.$frontendRepositories.channels.deleteMessage(message.id);

    return response;
  },
  async GET_USER_BY_ID({commit}, userId) {
    const {data} = await this.$frontendRepositories.channels.getUserById(userId);

    if(data.data) {
      commit('addUser', data.data)
    }
  },
  async LOAD_DELETE_MESSAGES({state}, latestTimeMessage) {
    const response = await this.$frontendRepositories.channels.loadMessageDelete(state.selectedChannel.id, latestTimeMessage);
    return response.data.data;
  },
  async UPDATE_ROOT_USER_CHANNEL({commit}, {channelId, user, role}) {
    return await this.$frontendRepositories.channels.updateRootUserChannel(
        channelId, {user_id: user.id, is_root: role}
    );
  },
  async SORT_CHANNEL({commit}, payload) {
    const {data} = await this.$frontendRepositories.channels.sortChannel(payload)
  }
}

export const mutations = {
  resetAllState: state => {
    state.selectedChannel = null;
    state.users = [];
    state.allUsers = [];
  },
  setChannels: (state, channels) => state.channels = channels,
  addChannel: (state, channel) => state.channels.push(channel),
  updateChannel: (state, {id, payload}) => {
    const channel = state.channels.find(channel => channel.id === id)

    channel.title = payload.title;
  },
  deleteChannel: (state, channel) => {
    const index = state.channels.indexOf(channel)

    state.channels.splice(index, 1)
    state.selectedChannel = null;
  },
  setSelectedChannel: (state, channel) => state.selectedChannel = channel,
  setMarkSeen: (state, channel) => {
    const index = state.channels.indexOf(channel)
    if(!state.channels[index]) {
      return false;
    }

    state.channels[index].un_read = 0;
  },
  setUsers: (state, users) => state.users = users,
  addUser: (state, user) => state.users.push(user),
  removeUser: (state, user) => {
    const userIndex = state.users.findIndex(item => item.id === user.id)

    state.users.splice(userIndex, 1)
  },
  setAllUsers: (state, users) => state.allUsers = users,
  setLatestMessageForChannel: (state, {channel_id, message}) => {
    const channel = state.channels.find(channel => channel.id === channel_id);

    if(channel) {
      channel.last_message = message
    }
  }
}
